import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { MDBCol, MDBRow } from "mdbreact";

import { COLORS, Input } from "abs-ui-components";

import absLogo from "../../../images/abs-logo-white.svg";
import { registerUser } from "../../../services/signInService";
import { emitToasterMsg } from "../../../services/toasterUtility";
import SsoLogin from "../SSO-SignIn/SignIn";
import { APP_TITLE } from "../../../common/header/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "../../SignInModule/SignIn.scss";
import { useDispatch } from "react-redux";
import {
	setUserInfo,
	setUserLoggedIn,
} from "../../../store/userInfo/userInfo.slice";
import axiosHttp from "../../../services/interceptor";

const RegistartionPage = () => {
	const {
		control,
		handleSubmit,
		formState: { errors },
		watch,
	} = useForm();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const [loginstatus, setLoginStatus] = useState(true);
	const [showPassword, setShowPassword] = useState(false);
	const [showconfirmPassword, setconfirmShowPassword] = useState(false);

	const registerNewUser = async (registerData) => {
		const userRegistrationObj = {
			firstName: registerData?.firstName,
			lastName: registerData?.lastName,
			officeLocation: registerData?.location,
			organization: registerData?.organization,
			email: registerData?.Email,
			password: registerData?.password,
			confirmPassword: registerData?.confirmPassword,
		};
		const response = await registerUser(userRegistrationObj);
		if (
			response &&
			response?.isSuccess !== undefined &&
			!response?.isSuccess
		) {
			emitToasterMsg("error", response?.errors?.[0]);
		} else if (
			response?.isSuccess &&
			response?.bearerToken &&
			response?.user
		) {
			await handleAccessToken(response?.bearerToken);
			dispatch(setUserLoggedIn(true));
			// localStorage.setItem("loginStatus", true);
			dispatch(setUserInfo(response?.user));

			navigate("/");
		}
	};

	const handleAccessToken = async (token) => {
		try {
			const res = await axiosHttp({
				url: `api/Accounts/StoreCookie`,
				method: "POST",
				data: { accessToken: token },
			});
		} catch (error) {
			console.error(error);
		}
	};

	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};
	const toggleconfirmPasswordVisibility = () => {
		setconfirmShowPassword(!showconfirmPassword);
	};

	const returnToLogin = () => {
		setLoginStatus(false);
	};

	return (
		<>
			{loginstatus ? (
				<div class="main-container">
					<div class="row justify-content-center align-items-center vh-100">
						<div class="registration-container d-flex justify-content-center align-items-center">
							<div>
								<div class="text-center">
									<img
										className="abs-logo"
										src={absLogo}
										alt="abs-logo"
									/>
								</div>
								<p className="emmision-text mt-3">
									{APP_TITLE}
								</p>
								<h4 className="login mt-3"> Register </h4>
								<form onSubmit={handleSubmit(registerNewUser)}>
									<MDBRow>
										<MDBCol md="6">
											<div className="input-content mt-3">
												<Controller
													name="firstName"
													control={control}
													defaultValue=""
													rules={{
														required:
															"First Name is required",
													}}
													render={({ field }) => (
														<Input
															{...field}
															id="firstName"
															type="text"
															autoFocus={false}
															className="password"
															placeholder="First Name"
														/>
													)}
												/>
											</div>
											{errors.firstName && (
												<p className="error">
													{errors.firstName.message}
												</p>
											)}
										</MDBCol>
										<MDBCol md="6">
											<div className="input-content mt-3">
												<Controller
													name="lastName"
													control={control}
													defaultValue=""
													rules={{
														required:
															"Last Name is required",
													}}
													render={({ field }) => (
														<Input
															{...field}
															id="lastName"
															type="text"
															autoFocus={false}
															className="password"
															placeholder="Last Name"
														/>
													)}
												/>
											</div>
											{errors.lastName && (
												<p className="error">
													{errors.lastName.message}
												</p>
											)}
										</MDBCol>
									</MDBRow>

									<div className="input-content mt-3">
										<Controller
											name="Email"
											control={control}
											defaultValue=""
											rules={{
												required: "Email is required",
												pattern: {
													value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
													message:
														"Invalid email address",
												},
											}}
											render={({ field }) => (
												<>
													<div>
														<Input
															required
															id="username"
															onChange={(e) => {
																field.onChange(
																	e
																);
															}}
															value={field.value}
															autoFocus={false}
															className="username"
															placeholder="Email"
														/>
													</div>
												</>
											)}
										/>
									</div>
									<span>
										{errors.Email && (
											<p className="error">
												{errors.Email.message}
											</p>
										)}
									</span>

									<div className="input-content mt-3">
										<Controller
											name="password"
											control={control}
											defaultValue=""
											type="password"
											rules={{
												required:
													"Password is required",
											}}
											render={({ field }) => (
												<>
													<div className="password-wrapper">
														<Input
															required
															id="password"
															type={
																showPassword
																	? "text"
																	: "password"
															}
															onChange={(e) => {
																field.onChange(
																	e
																);
															}}
															value={field.value}
															autoFocus={false}
															className="password"
															placeholder="Password"
														/>
														<span
															onClick={
																togglePasswordVisibility
															}
															className="register-faEye"
														>
															<FontAwesomeIcon
																icon={
																	showPassword
																		? faEyeSlash
																		: faEye
																}
															/>
														</span>
													</div>
												</>
											)}
										/>
									</div>

									<div>
										{errors.password && (
											<p className="error">
												{errors.password.message}
											</p>
										)}
									</div>
									<div className="input-content mt-3">
										<Controller
											name="confirmPassword"
											control={control}
											defaultValue=""
											type="password"
											rules={{
												required:
													"Confirm Password is required",
												validate: (value) =>
													value ===
														watch("password") ||
													"Passwords do not match",
											}}
											render={({ field }) => (
												<>
													<div className="password-wrapper">
														<Input
															required
															id="confirmPassword"
															type={
																showconfirmPassword
																	? "text"
																	: "password"
															}
															onChange={(e) => {
																field.onChange(
																	e
																);
															}}
															value={field.value}
															autoFocus={false}
															className="password"
															placeholder="Confirm Password"
														/>
														<span
															onClick={
																toggleconfirmPasswordVisibility
															}
															className="register-faEye"
														>
															<FontAwesomeIcon
																icon={
																	showconfirmPassword
																		? faEyeSlash
																		: faEye
																}
															/>
														</span>
													</div>
												</>
											)}
										/>
									</div>

									<div>
										{errors.confirmPassword && (
											<p className="error">
												{errors.confirmPassword.message}
											</p>
										)}
									</div>

									<MDBRow>
										<MDBCol md="6">
											<div className="input-content mt-3">
												<Controller
													name="organization"
													control={control}
													defaultValue=""
													type="text"
													rules={{
														required:
															"Organization is required",
													}}
													render={({ field }) => (
														<>
															<div>
																<Input
																	required
																	id="organization"
																	type="text"
																	onChange={(
																		e
																	) => {
																		field.onChange(
																			e
																		);
																	}}
																	value={
																		field.value
																	}
																	autoFocus={
																		false
																	}
																	className="password"
																	placeholder="Organization"
																/>
															</div>
														</>
													)}
												/>
											</div>
											<span>
												{errors.organization && (
													<p className="error">
														{
															errors.organization
																.message
														}
													</p>
												)}
											</span>
										</MDBCol>
										<MDBCol md="6">
											<div className="input-content mt-3">
												<Controller
													name="location"
													control={control}
													defaultValue=""
													type="text"
													rules={{
														required:
															"Location is required",
													}}
													render={({ field }) => (
														<>
															<div>
																<Input
																	required
																	id="location"
																	type="text"
																	onChange={(
																		e
																	) => {
																		field.onChange(
																			e
																		);
																	}}
																	value={
																		field.value
																	}
																	autoFocus={
																		false
																	}
																	className="password"
																	placeholder="Location"
																/>
															</div>
														</>
													)}
												/>
											</div>
											<span>
												{errors.location && (
													<p className="error">
														{
															errors.location
																.message
														}
													</p>
												)}
											</span>
										</MDBCol>
									</MDBRow>

									<button
										type="submit"
										primaryBackgroundColor={COLORS.RED.DARK}
										primaryColor={COLORS.RED.DARK}
										className="Sign-In mt-4 text-center"
									>
										Register
									</button>
								</form>

								<div className="text-center mt-4">
									<p
										className="register text-center"
										onClick={returnToLogin}
									>
										Sign in
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : (
				<SsoLogin />
			)}
		</>
	);
};
export default RegistartionPage;
